import React, { createContext, useContext, useState } from 'react';
import { STORAGE_KEYS, VOICE_NAME_MAPPING } from '../constants';

const StoryContext = createContext();

export const StoryProvider = ({ children }) => {
  const [fontSize, setFontSize] = useState(17);
  const [isTwoColumns, setIsTwoColumns] = useState(false);
  const [voicePreference, setVoicePreference] = useState(() => {
    const savedPreference = localStorage.getItem(STORAGE_KEYS.VOICE_PREFERENCE);
    
    if (savedPreference) {
      return savedPreference;
    }
    
    return 'male';
  });

  const handleFontSizeChange = (increment) => {
    setFontSize(prevSize => Math.max(12, prevSize + increment));
  };

  const handleColumns = () => {
    setIsTwoColumns(prev => !prev);
  };

  return (
    <StoryContext.Provider value={{
      fontSize,
      isTwoColumns,
      voicePreference,
      handleFontSizeChange,
      handleColumns,
      setVoicePreference,
    }}>
      {children}
    </StoryContext.Provider>
  );
};

export const useStory = () => useContext(StoryContext); 